import { ModuleProps } from 'types';
import { useApolloClient } from '@apollo/client';
import { useRouteMatch } from 'react-router-dom';
import useProductCache from 'store/cache/product-cache';

const useBreadcrumbs = ({ getBreadcrumbs, ...props }: ModuleProps) => {
  const [productCache] = useProductCache();
  const client = useApolloClient();
  const match = useRouteMatch();
  const breadcrumbs = getBreadcrumbs?.({ productCache, client, match, ...props }) ?? [];

  return breadcrumbs;
};

export default useBreadcrumbs;
